import script from "./StatisticsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./StatisticsPage.vue?vue&type=script&setup=true&lang=js"

import "./StatisticsPage.vue?vue&type=style&index=0&id=81e011da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81e011da"]])

export default __exports__